enum ScheduleType {
  LOCKED = 0,
  UNLOCKED,
  SCHEDULED,
  CANCELED
}

export default ScheduleType;
